import React from "react";
import Dialog from "../../common/ConfirmDialog.jsx";
import PublicLinkButton from "../edit/PublicLink.jsx";


const SaveSuccessDialog = ({ surveyApiId, ...rest }) => {
  return (
    <Dialog
      title={I18n.t("report_saved")}
      footerDisabled = {true}
      {...rest}
    >
        <PublicLinkButton
            surveyApiId= {surveyApiId}
            linkButtonLabel = {I18n.t("report_saved_description")}
            className="mb-1"
        />
    </Dialog>
  );
};

export default SaveSuccessDialog;